// @ts-strict-ignore
import { MainStoreUserEnvironmentState } from 'modules/main/store/ducks/userEnvironment';
import {
  NOTIFICATIONS,
  notificationIsDismissed,
} from 'utils/localNotifications';
import { isNonAdmin, isSalarySurveyCompleted } from 'utils/userEnvironment';

export const promoteSalarySurvey = ({
  allowDismissal,
  userEnvironment,
}: {
  allowDismissal?: boolean;
  userEnvironment: MainStoreUserEnvironmentState;
}) =>
  (!allowDismissal ||
    !notificationIsDismissed(NOTIFICATIONS.SALARY_SURVEY_CTA)) &&
  userEnvironment.isUserLoaded &&
  userEnvironment.isEnvironmentLoaded &&
  CURRENT_LOCALE === 'en' &&
  userEnvironment.environment.isUS &&
  !isSalarySurveyCompleted(userEnvironment.user) &&
  (!userEnvironment.user || isNonAdmin(userEnvironment.user));

export const promoteSalarySurveySearchAd = ({
  userEnvironment,
}: {
  userEnvironment: MainStoreUserEnvironmentState;
}) =>
  userEnvironment.isUserLoaded &&
  userEnvironment.isEnvironmentLoaded &&
  CURRENT_LOCALE === 'en' &&
  userEnvironment.environment.isUS &&
  !isSalarySurveyCompleted(userEnvironment.user);
